export default __webpack_public_path__ + "static/media/col.e0c29b9b.svg";